module.exports = __webpack_public_path__ + "static/dizel-9535563b6a16e227da88700a8923dbd2.png";